import styles from '../scss/main.scss'
import WOW from "wow.js";

$(() => {
    var windowsize = $(window).width();

    // custom select
    $('select').each(function(){
        var $this = $(this), numberOfOptions = $(this).children('option').length;

        $this.addClass('select-hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');

        // chose active lang
        $this.children('option').each(function () {
          if($(this).is(':selected')){
               $styledSelect.text($(this).text());
            }
        })


        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);

        for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
                text: $this.children('option').eq(i).text(),
                rel: $this.children('option').eq(i).val()
            }).appendTo($list);
        }

        var $listItems = $list.children('li');

        $styledSelect.click(function(e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function(){
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
        });

        $listItems.click(function(e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $list.hide();

            //change lang
            $(this).parents().eq(2).submit()
        });

        $(document).click(function() {
            $styledSelect.removeClass('active');
            $list.hide();
        });
    });

    //menu bg toggle
    function toggleMenuBg() {
        if($(window).scrollTop() > 5 && !$('.main-navigation').hasClass('small')) {
            $('.main-navigation').addClass('small');
        }else if($(window).scrollTop() <= 5 && $('.main-navigation').hasClass('small')){
            $('.main-navigation').removeClass('small');
        }
    }

    $(window).scroll(function(){
        toggleMenuBg();
    });
    toggleMenuBg();

    // search modal
    $('.toggle-search-modal').on('click', function () {
      $('.search-modal').fadeToggle(250)
    })

    $('.close-modal').on('click', function () {
      $('.modal').fadeOut(250)
      $('#keyword').val('')
      $('#el_search_results h4').html('')
      $('.table-container').hide()
    })

    // togle mobile menu
    $('.toggle-mobile, .close-menu').on('click', function () {
      $('.links').toggleClass('open')
    })

    // reveal
    new WOW().init();
});


(function(){
  function id(v){return document.getElementById(v); }
  function loadbar() {

    var ovrl = id("overlay"),
        stat = id("progstat"),
        img = document.images,
        c = 0;
        var tot = img.length;

    function imgLoaded(){
      c += 1;
      var perc = ((100/tot*c) << 0) +"%";
      stat.innerHTML = ""+ perc;
      if(c === tot) return doneLoading();
    }

    if(tot === 0){
       stat.innerHTML = ""+ 100 +'%';
       doneLoading();
    }

    function doneLoading(){
      jQuery('#overlay').fadeOut(500)
    }

    for(var i=0; i<tot; i++) {
      var tImg     = new Image();
      tImg.onload  = imgLoaded;
      tImg.onerror = imgLoaded;
      tImg.src     = img[i].src;
    }
  }
  document.addEventListener('DOMContentLoaded', loadbar, false);
}());



// WEBPACK FOOTER //
// ./src/js/main.js